import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ReviewsSummaryComponent} from 'projects/common/components/reviews-summary/reviews-summary.component';
import {ReviewsModule} from '@shopping-angular-components/reviews';
import {MainTitleModule} from 'projects/common/components/main-title/main-title.module';



@NgModule({
  declarations: [ReviewsSummaryComponent],
  imports: [
    CommonModule,
    ReviewsModule,
    MainTitleModule
  ],
  exports: [ReviewsSummaryComponent]
})
export class ReviewsSummaryModule { }
